var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-panel"},[_c('div',{staticClass:"admin-panel-fixbox"},[_c('div',{staticClass:"admin-content"},[_c('router-view',{staticClass:"view"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }